import { ClientConfig } from 'client/configuration';

export function getConfigOptions(isAllowBypassApiGateway) {
  return {
    isDisableAWSAuth: ClientConfig.get('carBuying').capOneAPI.disableAWSAuth,
    isAllowBypassApiGateway,
    baseUrl: isAllowBypassApiGateway
      ? ClientConfig.get('carBuying').capOneApiUrlBypassApiGateway
      : ClientConfig.get('carBuying').capOneApiUrl,
  };
}
